import { Box, Input as ChakraInput, Text } from '@chakra-ui/react'
import { forwardRef } from 'react'

export const InputInnovationText = forwardRef(({ label, ...rest }, ref) => {
  return (
    <Box
      position="relative"
      h="37px"
      display="flex"
      alignItems="center"
      cursor="pointer"
      bgColor="#fff"
      px={2}
      border="1px solid #378BBF"
      borderRadius="4px"
      {...rest}
    >
      <Text
        flex={1}
        color="#378BBF"
        fontSize="13px"
        fontWeight="semibold"
        as="label"
        htmlFor={rest.name}
        cursor="pointer"
      >
        {label}:
      </Text>
      {/* Adicionado ref passando para ChakraInput */}
      <ChakraInput
        flex={1}
        id={rest.name}
        border="0"
        padding="0"
        outline="0"
        boxShadow="0"
        h="100%"
        name={rest.name}
        _focus={{
          boxShadow: '0',
        }}
        ref={ref} // Aqui está o ref passado corretamente
      />
    </Box>
  )
})
